// extracted by mini-css-extract-plugin
export default {"buttons":"buttons--Ndyxp-0IGL","icon":"icon--r-8kAy9SQh"};